import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Monitor, Image, ListVideo, Clock } from 'lucide-react';
import { DisplayList } from './displays/DisplayList';
import { DisplayStatusPanel } from './displays/DisplayStatusPanel';
import { KioskControlPanel } from './displays/KioskControlPanel';
import { ContentLibrary } from './content/ContentLibrary';
import { PlaylistList } from './playlists/PlaylistList';
import { ScheduleList } from './scheduling/ScheduleList';

interface SignageTabProps {
  businessId: string;
}

export function SignageTab({ businessId }: SignageTabProps) {
  const [activeTab, setActiveTab] = useState('displays');

  return (
    <div className="space-y-6">
      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="grid w-full max-w-lg grid-cols-4">
          <TabsTrigger value="displays" className="flex items-center gap-2">
            <Monitor className="w-4 h-4" />
            <span className="hidden sm:inline">Displays</span>
          </TabsTrigger>
          <TabsTrigger value="content" className="flex items-center gap-2">
            <Image className="w-4 h-4" />
            <span className="hidden sm:inline">Content</span>
          </TabsTrigger>
          <TabsTrigger value="playlists" className="flex items-center gap-2">
            <ListVideo className="w-4 h-4" />
            <span className="hidden sm:inline">Playlists</span>
          </TabsTrigger>
          <TabsTrigger value="schedules" className="flex items-center gap-2">
            <Clock className="w-4 h-4" />
            <span className="hidden sm:inline">Schedules</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="displays" className="space-y-6">
          {/* Status Panels */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <DisplayStatusPanel businessId={businessId} />
            <KioskControlPanel businessId={businessId} />
          </div>

          {/* Display List */}
          <DisplayList businessId={businessId} />
        </TabsContent>

        <TabsContent value="content" className="space-y-6">
          <ContentLibrary businessId={businessId} />
        </TabsContent>

        <TabsContent value="playlists" className="space-y-6">
          <PlaylistList businessId={businessId} />
        </TabsContent>

        <TabsContent value="schedules" className="space-y-6">
          <ScheduleList businessId={businessId} />
        </TabsContent>
      </Tabs>
    </div>
  );
}

export default SignageTab;
